import * as React from "react";
const Needle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={100} height={119} fill="none">
    <path
      fill="#353535"
      fillRule="evenodd"
      d="M52.21 1.405a3 3 0 0 0-4.42 0L26.007 25.123C10.508 33.615 0 50.08 0 69c0 27.614 22.386 50 50 50s50-22.386 50-50c0-18.92-10.508-35.385-26.006-43.877L52.209 1.405Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Needle;
